import React from "react";
import logo from "./logo.svg";
import "./App.css";
import FlowApp from "./components/FlowApp";

function App() {
  return (
    <div className="App">
      <FlowApp />
    </div>
  );
}

export default App;
